<script>
  import { fade } from 'svelte/transition';
  import { flip } from 'svelte/animate';
  import { cubicOut } from 'svelte/easing';
  import { isFirstLoad } from '../stores.js';
  import ResultBlock from './ResultBlock.svelte';
  import LoadingBlock from './LoadingBlock.svelte';

  /**
   * props
   */
  export let items;

  /**
   * stores
   */
  let isFirstLoad_value;
  isFirstLoad.subscribe(value => {
    isFirstLoad_value = value;
  });

  /**
   * サムネイルのパスを返す
   * primaryのパスがfalseならばsecondaryのパスを、
   * secondaryのパスもなければデフォルト画像のパスを返す
   * 
   * @param primary 優先的に使う画像 item.featured_image.thumbnail
   * @param secondary 次に使う画像 
   */
  function getImagePath(primary, secondary) {
    if(primary) return primary;
    if(secondary) return secondary;
    return '/wp-content/themes/kids-programming/images/item-default-eyecatch.png';
  }
</script>

<section class="item-all">
  <header class="item-list-heading">
    <div class="header-tool">ツール</div>
    <div class="header-kind">タイプ</div>
    <div class="header-type">目的</div>
    <div class="header-target">対象年齢</div>
    <div class="header-price">価格</div>
  </header>
  <div class="item-list">
    {#if items}
      {#each items as item (item.id)}
        <div class="item" id="{item.id}"
          in:fade="{{duration:500, easing:cubicOut}}"
          out:fade="{{duration:150, easing:cubicOut}}"
          animate:flip="{{duration:350, delay:50, easing:cubicOut}}"
        >
          <div class="item-image">
            <img 
              class="featured_image"
              src="{getImagePath(item.featured_image.thumbnail, item.featured_image.kp_thumb)}"
              width="150"
              height="150"
              alt="{item.post_title}の画像"
            />
          </div>
          <div class="item-name">
            <a href="{item.url}">{item.post_title}</a><br>
            <small>{item.rubi}</small>
          </div>
          <div class="item-kind"><span class="kind-badge {item.tax_kind_slug}">{item.tax_kind_name}</span></div>
          <div class="item-type">{item.programming_type_display}</div>
          <div class="item-target">{item.target_age_display}</div>
          <div class="item-price">{item.price === 0? "無料" : "¥" + item.price.toLocaleString() + "-"}</div>
        </div>
      {:else}
        {#if isFirstLoad_value}
        <LoadingBlock/>
        {:else}
        <ResultBlock/>
        {/if}
      {/each}
    {/if}
  </div>
</section>

<style>
  .item-all {
    margin: 1rem 0;
    width: 100%;
  }
  .item-list-heading,
  .item {
    display: grid;
    grid-template-columns: 50px 1fr 1fr;
    padding: 8px;
    gap: 8px;
    border-bottom: 1px solid #ccc;
  }
  @media(min-width: 993px) {
    .item-list-heading,
    .item {
      /* grid-template-columns: 50px 3fr 1fr 1fr 1fr 1fr; */
      grid-template-columns: 50px 9fr 3fr 3fr 3fr 2fr;
    }
  }

  .item-list-heading {
    background: #212529;
    color: white;
    font-size: .875rem;
  }
  
  .item-list-heading > .header-tool {
    grid-column: 1 / 3;
  }

  /* column style */
  .item-kind,
  .item-type,
  .item-target,
  .item-price {
    display: grid;
    place-items: center start;
    font-size: 0.875rem;
  }
  .item-price {
    place-items: center end;
  }
  .item-name > small {
    font-size: 0.6rem;
  }

  /* kind-badge */
  .kind-badge {
    display: inline-block;
    padding: 0.2rem 0.8rem 0.2rem 1.8rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-clip: border-box;
    background-position: 5px;
    border-radius: 5px;
    color: #fff;
    font-size: 0.6rem;
  }
  .kind-badge.app {
    background-color: #e9b225;
    background-image: url(images/kind-icon-app.svg);
  }
  .kind-badge.gadget {
    background-color: #ef7738;
    background-image: url(images/kind-icon-gadget.svg);
  }
  .kind-badge.micom {
    background-color: #8c69d4;
    background-image: url(images/kind-icon-micom.svg);
  }
  .kind-badge.robot {
    background-color: #71c813;
    background-image: url(images/kind-icon-robot.svg);
  }
  .kind-badge.sensor {
    background-color: #006fc4;
    background-image: url(images/kind-icon-sensor.svg);
  }
  .kind-badge.unplugged {
    background-color: #dc4838;
    background-image: url(images/kind-icon-unplugged.svg);
  }

    /* hide / show */
    @media(max-width: 992px) {
    .header-type,
    .header-target,
    .header-price,
    .item-type,
    .item-target,
    .item-price {
      display: none;
    }
  }
</style>